import { render, staticRenderFns } from "./XcqSingleImg.vue?vue&type=template&id=12210aae&scoped=true&"
import script from "./XcqSingleImg.vue?vue&type=script&lang=ts&"
export * from "./XcqSingleImg.vue?vue&type=script&lang=ts&"
import style0 from "./XcqSingleImg.vue?vue&type=style&index=0&id=12210aae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12210aae",
  null
  
)

export default component.exports